export const SpinnerComponent = {
  templateUrl: 'components/Loaders/spinner/spinner.html',
};
